import actions from "./actions";

const fetchPastOrders = actions.fetchPastOrders;

export default {
  fetchPastOrders,
};
